// extracted by mini-css-extract-plugin
export default {"header":"LiquidityFormHeader_header__sABfi"};